module.exports = __webpack_public_path__ + "img/card-icon.0407c59e.png";